@if (dataService.executiveSummaryLoading | async; as loading) {
  <div class="z-fx-col z-fx-center-center z-fx-gap-16 z-fx-w100 z-fx-auto spinner-container">
    <zef-spinner-ai-loading class="larger"></zef-spinner-ai-loading>
    <div class="zef-text-p1">{{ loading }}</div>
  </div>
} @else {
  @if (getContent(); as content) {
    @if (data) {
      <button class="close-button" mat-icon-button color="secondary" matDialogClose><mat-icon>close</mat-icon></button>
    }
    <div
      class="z-fx-col z-fx-auto z-fx-start-center executive-summary-container"
      [style.margin-top.px]="!data?.noMargin ? 16 : 0"
    >
      <ng-scrollbar class="z-fx-col z-fx-w100 z-fx-auto">
        <div
          id="executiveSummaryTextContent"
          class="z-fx-col z-fx-gap-24 text-content"
          [innerHTML]="parseMarkdownToHtml(content) | safeHtml"
        ></div>
        @if (getMetadata(); as metadata) {
          <div class="z-fx-col z-fx-gap-16 metadata-container">
            @if ({ isMetadataVisible: isMetadataVisible$ | async }; as $) {
              <div
                class="metadata-toggle zef-text-p2-link-muted"
                (click)="isMetadataVisible$.next(!$.isMetadataVisible)"
              >
                <span *ngIf="!$.isMetadataVisible" i18n>Show metadata</span>
                <span *ngIf="$.isMetadataVisible" i18n>Hide metadata</span>
              </div>
              <div class="z-fx-col z-fx-gap-4 metadata" *ngIf="$.isMetadataVisible">
                <span class="zef-text-p2" i18n>
                  Generated by AI on {{ metadata?.time | date: 'LLLL d, yyyy @ HH:mm' }}
                </span>
                <span *ngIf="metadata?.filters" class="zef-text-p2" i18n>
                  Filters (only available in English): "{{ metadata.filters }}"
                </span>
                <span *ngIf="metadata?.respondents" class="zef-text-p2" i18n>
                  Respondents: {{ metadata.respondents }}
                </span>
                <span *ngIf="metadata?.userProfile" class="zef-text-p2" i18n>
                  User profile: "{{ metadata.userProfile }}"
                </span>
                <span *ngIf="metadata?.companyProfile" class="zef-text-p2" i18n>
                  Organization profile: "{{ metadata.companyProfile }}"
                </span>
                <span *ngIf="metadata?.themes" class="zef-text-p2" i18n>
                  Thematic analyses: "{{ metadata.themes }}"
                </span>
                <span *ngIf="metadata?.mergedSurveys" class="zef-text-p2" i18n>
                  Other surveys included: "{{ metadata.mergedSurveys }}"
                </span>
              </div>
            }
          </div>
        }
      </ng-scrollbar>
    </div>
  } @else {
    <div class="z-fx-col z-fx-auto z-fx-center-center z-fx-gap-16 no-content">
      <div class="z-fx-col z-fx-center-center">
        <img src="assets/decos/art-nothing.png" height="64px" width="64px" class="art-nothing" alt="nothing" />
        <div class="zef-text-p1-muted" i18n>Executive summary not generated</div>
      </div>
    </div>
  }
}
